module.exports = __webpack_public_path__ + "static/media/avatar49.2140ec62.png";